export default "__VITE_ASSET__a$05cMNM__"